import { ContentBox } from "@msuite/ui/app-shell";
import { BlankSlate } from "@msuite/ui/blank-slate";

export function MySpace() {
	/** Render */
	return (
		<ContentBox>
			<BlankSlate />
		</ContentBox>
	);
}
